'use strict';

var ListItem = require('../ListItem');
var getMarketplaceLinks = require('../links/marketplace-links');

function renderMarketplaceListItems(depsArg) {
	var marketplaceLinks = getMarketplaceLinks.renderMarketplaceLinks(depsArg);

	return {

		renderHomeListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: marketplaceLinks.renderHomeLink(config, deps),
				className: 'ad-component_list-item--home'
			})).render(config, deps);
		},

		renderLogInListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: marketplaceLinks.renderLogInLink(config, deps),
				className: 'ad-component_list-item--login'
			})).render(config, deps);
		},

		renderLogOutListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: marketplaceLinks.renderLogOutLink(config, deps),
				className: 'ad-component_list-item--logout'
			})).render(config, deps);
		},

		renderMyAppsListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: marketplaceLinks.renderMyAppsLink(config, deps),
				className: 'ad-component_list-item--myapps'
			})).render(config, deps);
		},

		renderSignUpListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: marketplaceLinks.renderSignUpLink(config, deps),
				className: 'ad-component_list-item--signup'
			})).render(config, deps);
		}
	};
}

module.exports = {
	renderMarketplaceListItems: renderMarketplaceListItems
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/list-items/marketplace-list-items.js
// module id = 16
// module chunks = 0